import { dapvApi } from 'services/providers/dapv';
import {
    CreateUserProjectRequestPayload,
    UpdateUserProjectRequestPayload,
    UserProjectRequest,
    UserProjectRequestPayload,
    UserProjectRequestResponse,
    UserProjectRequestsResponse,
    UserProjectRequestSinglePayload
} from './request.types';
import { ApiResponse } from 'services/providers/dapv.types';
import { PersonProjectEvent } from '../event/event.types';

const requestApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getUserProjectRequests: build.mutation<UserProjectRequestsResponse, UserProjectRequestPayload>({
            query: ({ id }: UserProjectRequestPayload) => {
                return {
                    url: `/app/projects/${id}/requests`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<UserProjectRequest>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getUserProjectRequest: build.mutation<ApiResponse<UserProjectRequest>, UserProjectRequestSinglePayload>({
            query: ({ id, requestId }: UserProjectRequestSinglePayload) => {
                return {
                    url: `/app/projects/${id}/requests/${requestId}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<UserProjectRequest>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createUserProjectRequest: build.mutation<UserProjectRequestResponse, CreateUserProjectRequestPayload>({
            query: (payload: CreateUserProjectRequestPayload) => {
                return {
                    url: `/app/projects/${payload.projectId}/requests`,
                    method: 'POST',
                    body: {
                        ...payload
                    }
                };
            },
            transformResponse: (response: ApiResponse<UserProjectRequest>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateUserProjectRequest: build.mutation<UserProjectRequestResponse, UpdateUserProjectRequestPayload>({
            query: (payload: UpdateUserProjectRequestPayload) => {
                return {
                    url: `/app/projects/${payload.projectId}/requests/${payload.requestId}`,
                    method: 'PUT',
                    body: {
                        ...payload
                    }
                };
            },
            transformResponse: (response: ApiResponse<UserProjectRequest>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        // USER REQUESTS
        getUserProjectRequestsFromUser: build.mutation<UserProjectRequestsResponse, UserProjectRequestPayload>({
            query: ({ id }: UserProjectRequestPayload) => {
                return {
                    url: `/user/projects/${id}/requests`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<UserProjectRequest>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createUserProjectRequestFromUser: build.mutation<UserProjectRequestResponse, CreateUserProjectRequestPayload>({
            query: (payload: CreateUserProjectRequestPayload) => {
                return {
                    url: `/user/projects/${payload.projectId}/requests`,
                    method: 'POST',
                    body: {
                        ...payload
                    }
                };
            },
            transformResponse: (response: ApiResponse<UserProjectRequest>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useCreateUserProjectRequestMutation,
    useGetUserProjectRequestsMutation,
    useUpdateUserProjectRequestMutation,
    useGetUserProjectRequestsFromUserMutation,
    useGetUserProjectRequestMutation
} = requestApi;
